import React from 'react'

function CompanyName() {
    const CompanyName = "The Bagdad Chase Mining Company"


    return (
        <>
            <span aria-label="The Bagdad Chase Mining Company" title='The Bagdad Chase Mining Company'>{CompanyName}</span>


        </>
    )
}

export default CompanyName